import {
  MapTool,
  DataQuery
} from "cartovista";
import "../../css/SelectionStats.css";﻿

    export default class SelectionStats extends MapTool {
      constructor() {
        super($("#selectionStats_btn")[0], {
            "map": window.cartovista.externalInterface.map, 
            "mapController": window.cartovista.getMapController(window.cartovista.externalInterface.map)}, {
            spriteCssClass: "cv-icon sigmaIcon",
            onClick: function(){
                $("#selectionStats_container").toggleClass("cv-invisible");
            },
        });
        this._map = window.cartovista.externalInterface.map;
        this._mapController = window.cartovista.getMapController(this._map);
        this._map.addEventListener(this._map.EVENTS.SELECTION_LAYER_CHANGED, this._initContainer, this);
        this._map.addEventListener(this._map.EVENTS.SELECTION_CHANGED, this._setStatsContent, this);
        this._map.addEventListener(this._map.EVENTS.ACTIVE_THEME_SET_CHANGED, this._initContainer, this);

        this._$btn = $("#selectionStats_btn");
        this._$popup = $("#selectionStats_container");
        this._$btn.append('<span class="k-icon k-i-arrow-60-down"></span>');
        const pourcentageMeanConfig = _.find(C.MAP_TOOLS.SELECTION_STATS.STATS, (statsConfig) => statsConfig.ID == "PERCENTAGE_MEAN");
        this._$selectionStatsCollapse = $('<div>' +
                                                  '<h5><strong>Statistiques de la sélection</strong></h5>' +
                                                  '<div class="selectionStats_content">' +
                                                      '<strong>Couche:</strong>&nbsp;<span id="selectionStats_layerName"></span>' +
                                                  '</div>' +
                                                  '<div class="selectionStats_content">' +
                                                      '<strong>Nombre d\'entités sélectionées:</strong>&nbsp;<span class="selectionStats_stat" data-stat="COUNT"></span>' +
                                                  '</div>' +
                                                  '<div class="selectionStats_content">' +
                                                      '<strong>Champ à utiliser:</strong>&nbsp;<select id="selectionStats_dropDown"></select>' +
                                                  '</div>' +
                                                  '<div class="selectionStats_content">' +
                                                      '<span style="line-height:22px;"><strong>Somme:</strong>&nbsp;<span class="selectionStats_stat" data-stat="SUM"></span></span>' +
                                                      (C.MAP_TOOLS.SELECTION_STATS.STATS ?
                                                      '<button class="selectionStats_toggleStatsBtn btn btn-xs float-end" type="button" title="Afficher plus de statistiques"><i class="bi bi-plus-lg"></i></button>' +
                                                      '<button class="selectionStats_toggleStatsBtn btn btn-xs float-end" type="button" title="Afficher moins de statistiques" style="display:none;"><i class="bi bi-dash"></i></button>' : "") +
                                                  '</div>' +
                                                  (C.MAP_TOOLS.SELECTION_STATS.STATS ?
                                                  '<div id="selectionStats_statsPlus" style="display:none;">' +
                                                      _.map(_.reject(C.MAP_TOOLS.SELECTION_STATS.STATS, (statsConfig) => statsConfig.ID == "PERCENTAGE_MEAN"), function(statsConfig){
                                                          return  '<div class="selectionStats_content">' +
                                                                      '<strong>' + statsConfig.TITLE + '</strong>&nbsp;<span class="selectionStats_stat" data-stat="' + statsConfig.ID + '"></span>' +
                                                                  '</div>';
                                                      }).join("") +
                                                  '</div>' : '') +
                                                  (pourcentageMeanConfig ?
                                                  '<div class="selectionStats_content">' +
                                                      '<strong>' + pourcentageMeanConfig.TITLE + '</strong>&nbsp;<span class="selectionStats_stat" data-stat="' + pourcentageMeanConfig.ID + '"></span><span>%</span>' +
                                                  '</div>' : "") +
                                              '</div>');
        this._$popup.append([this._$selectionStatsCollapse]);
        this._$kendoDropDown = this._$selectionStatsCollapse.find("#selectionStats_dropDown").kendoDropDownList({
            "dataTextField": "name",
            "popup": {
                "appendTo": this._$selectionStatsContainer
            },
            "change": this._setStatsContent.bind(this)
        }).data("kendoDropDownList");
        this._$selectionStatsCollapse.find(".selectionStats_toggleStatsBtn").click(this._onToggleStatsBtnClicked.bind(this));
        this._initContainer();
      }

    _onToggleStatsBtnClicked(evt) {
        this._$selectionStatsCollapse.find(".selectionStats_toggleStatsBtn").toggle();
        this._$selectionStatsCollapse.find("#selectionStats_statsPlus").toggle();
    };

    _initContainer() {
        this._$selectionStatsCollapse.find("#selectionStats_layerName").html(this._map.selectionLayer ? this._map.selectionLayer.name : "");
        this._$selectionStatsCollapse.find(".selectionStats_stat").html('<em>N/A</em>');
        if (this._map.selectionLayer) {
            var selectionStatsConfig = _.find(C.MAP_TOOLS.SELECTION_STATS.LAYERS, {"LAYER_ID" : this._map.selectionLayer.id});
            this._setDropDownDataSource(selectionStatsConfig);
            this._setStatsContent();
        }
    };

    _setDropDownDataSource(selectionStatsConfig) {
        var dataSource = typeof selectionStatsConfig == "undefined" ? [] : _.map(selectionStatsConfig.DATACOLUMNS, function(dataColumnConfig) {
            var dataColumn = this._map.selectionLayer.getDataTable(dataColumnConfig.DATATABLE_ID).getDataColumns(dataColumnConfig.ID)[0];
            return _.assign(dataColumnConfig, {"name": dataColumn.name});
        }.bind(this));
        this._$kendoDropDown.setDataSource(dataSource);
        this._$kendoDropDown.select(0);
    };


    _setStatsContent() {
        var dataItem = this._$kendoDropDown.dataItem();
        if (dataItem) {
            this._getSelectionStats(dataItem);
        }
    };

    _getSelectionStats(dataItem) {
        var stats,
            dataTable = this._map.selectionLayer.getDataTable(dataItem.DATATABLE_ID),
            dataColumn = dataTable.getDataColumns(dataItem.ID)[0];
        this._map.selectionLayer.computeSelectionStack(function(linkingIds){
            var dataQuery = new DataQuery([dataColumn], linkingIds, _.concat(_.pull(_.map(C.MAP_TOOLS.SELECTION_STATS.STATS, "ID"), "PERCENTAGE_MEAN"), ["COUNT", "SUM"]));
            //dataQuery.statisticsOnly = true; //bugg CV7.4
            dataQuery.execute(function(result) {
                stats = result.statisticsValues[dataItem.DATATABLE_ID][dataItem.ID];
                if (_.find(C.MAP_TOOLS.SELECTION_STATS.STATS, (statsConfig) => statsConfig.ID == "PERCENTAGE_MEAN")) {
                    stats.PERCENTAGE_MEAN = window.statistics ? stats.SUM / window.statistics.nbr_mean * 100 : null;
                }
                _.forEach(stats, function(value, statEnum) {
                    var value = value ? value % 1 === 0 ? value : _.round(value, 2) : 0;
                    this._$selectionStatsCollapse.find(".selectionStats_stat[data-stat='" + statEnum + "']").html(value.toLocaleString("fr-CA"))
               }.bind(this));
            }.bind(this));
        }.bind(this));
    };

}
